export interface KeyValueModel {
  key: string;
  value: string;
  default?: boolean;
}

export const DEFAULT_KEY_VALUE_MODEL: KeyValueModel = {
  key: '',
  value: 'None',
  default: true
};
